module.exports = __webpack_public_path__ + "img/hans_joachim_richert.5f2379d7.jpg";